export const BASE_API = process.env.REACT_APP_API
export const AUTH_API = process.env.REACT_APP_AUTH
export const DATA_API = process.env.REACT_APP_DATA
export const ASSEMBLER_API = process.env.REACT_APP_ASSEMBLER
export const SEARCH_API = process.env.REACT_APP_SEARCH